// Copyright (c) 2017 Deere & Company

import PipCode from '@deere/cps-it.warranty-model-factory/lib/pip-code';
import t from 'tcomb';

const PipCodeRequests = t.list(PipCode, 'PipCodeRequests');

export const getDefaultState = () => new PipCodeRequests([]);

export default PipCodeRequests;



// WEBPACK FOOTER //
// ./src/tcsm/wip/state/pip-code-requests.js